export default () => ({
  paper: {
    flex: 1,
    display: 'flex',
  },
  input: {
    marginLeft: 8,
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
});
